import * as React from 'react';

const Products = () => {
    return(
        <div id="servicos">
            <div className="container-fluid text-center align-items-center col-sm-6 col-md-8">
                <p className="extra-large-text bold s-margin text-center roxo-e">SERVIÇOS</p>
                <h3>
                Desenvolvemos projetos de tecnologia e inovação buscando criar parcerias duradouras e co-criar soluções escaláveis.
                </h3>
            </div>
            <div className="container-fluid products-f-block col-sm-12 col-md-12">
                <div className="col-sm-12 col-md-6 align-items-center products-f-block-child roxo-escuro ">
                    <span className="extra-large-text bold upper">Biz Scrum</span>
                    <p className="small-text-serv white">
                        Desenvolvimento de software ágil medido por indicadores de performance e não somente por prazos.
                    </p>

                    <p className="small-text-serv white">
                        Combinamos tecnologia e visão de negócios para ir além de desenvolvedores tradicionais de TI.
                    </p>
                </div>
                <div className="col-sm-12 col-md-6 align-items-center products-f-block-child roxo-claro">
                    <span className="extra-large-text bold upper">Value-based innovation</span>
                    <p className="small-text-serv white">
                    Hackathons, programas, workshops, labs, os formatos de inovação estão proliferando e cada um tem seu propósito.
                    </p>

                    <p className="small-text-serv white">
                    Criamos projetos customizados para empresas utilizando Design Doing, nossa metodologia de inovação.
                    </p>
                </div>
            </div>

            <div className="container-fluid products-f-block invert col-sm-12 col-md-12">
                <div className="col-sm-12 col-md-6 align-items-center products-f-block-child roxo-claro ">
                    <span className="extra-large-text bold upper">Product Lab</span>
                    <p className="small-text-serv white">
                    Tem uma ideia de negócio, mas quer testar antes de investir?
                    Quer tirar uma ideia nova do papel, mas não consegue dar foco nela no dia-a-dia?
                    </p>
                    <p className="small-text-serv white">
                    Nós criamos o MVP e apoiamos na validação do conceito!
                    </p>
                </div>
                <div className="col-sm-12 col-md-6 align-items-center products-f-block-child roxo-escuro">
                    <span className="extra-large-text bold upper">Entrepreneur-as-a-Service</span>
                    <p className="small-text-serv white">
                    Em projetos já em fase operacional, caso a empresa não tenha intraempreendedor dedicado ao projeto, complementamos a equipe com um Entrepreneur-in-Residence.
                    </p>


                </div>
            </div>
        </div>
    );
};
export default Products;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProductsComponent.tsx